import { render, staticRenderFns } from "./ModalCutOffVehicle.vue?vue&type=template&id=161d81a9&"
import script from "./ModalCutOffVehicle.vue?vue&type=script&lang=js&"
export * from "./ModalCutOffVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports